import React from "react";
import Input from "Components/input/Input";
import TextArea from "Components/textArea/TextArea";
import Toggle from "Components/toggle/Toggle";
import DayPicker from "Components/dayPicker/DayPicker";
import Button from "Components/button/Button";
import WarningBanner from "Components/warningBanner/WarningBanner";
import TranslatedString from "Components/TranslatedString";
import HourPicker from "Components/hourPicker/HourPicker";

import t from "Utils/translation";
import cx from "classnames";
import s from "./autoresponderEmailAccounts.scss";

export default class AutoresponderForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewFields: [
        "autoresponder_enabled",
        "autoresponder_subject",
        "autoresponder_body",
        "autoresponder_end_hour",
        "autoresponder_start_hour",
        "autoresponder_end_date",
        "autoresponder_start_date",
        "autoresponder_intervals_enabled",
      ],
    };
  }

  componentWillUnmount() {
    this.props.resetFields(...this.state.viewFields);
  }

  render() {
    const { isFormLoading, setFormFieldValue, submitForm, formData, formErrors } = this.props;

    return (
      <form className={s.autoresponder} method="post" onSubmit={(e) => submitForm(e, this.state.viewFields)}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!formErrors.onForm && !this.props.areFieldsPristine(...this.state.viewFields) && (
              <WarningBanner color="yellow-text" msg={<TranslatedString>infoMsg.unsaveChanged</TranslatedString>} />
            )}
            {formErrors.onForm && <WarningBanner msg={formErrors.onForm} color="red" />}
          </div>
          <div className={s.infoBtnGroup}>
            <Button className={s.docsBtn} docsKey="emailAccount_settings" color="docs" type="button">
              button.docs
            </Button>
            <Button className={s.saveBtn} type="submit" loading={isFormLoading} disabled={!this.props.canEdit}>
              button.save
            </Button>
          </div>
        </div>
        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.autoresponder.title")}</div>
              <div className="sectionDesc">{t("settings.sections.autoresponder.desc")}</div>
            </div>
            <div className="formsSectionSP">
              <Toggle
                className="inputFull2"
                label={t("input.label.enableAutoresponder")}
                name="autoresponder_enabled"
                onChange={setFormFieldValue}
                checked={formData.bounce_mail ? false : formData.autoresponder_enabled}
                errors={formErrors.autoresponder_enabled}
                disabled={formData.bounce_mail || !this.props.canEdit}
                hint={formData.bounce_mail && t("input.hint.autoresponder")}
              />

              <Input
                className="inputFull2"
                name="autoresponder_subject"
                label={t("input.label.message.subject")}
                placeholder={t("input.placeholder.message.subject")}
                type="text"
                errors={formErrors.autoresponder_subject}
                onChange={setFormFieldValue}
                value={formData.autoresponder_subject}
                required={formData.autoresponder_enabled}
                disabled={!formData.autoresponder_enabled || !this.props.canEdit}
              />

              <TextArea
                className={cx("inputFull2", "inputAddMargin")}
                name="autoresponder_body"
                label={t("input.label.message.body")}
                value={formData.autoresponder_body}
                errors={formErrors.autoresponder_body}
                onChange={setFormFieldValue}
                required={formData.autoresponder_enabled}
                disabled={!formData.autoresponder_enabled || !this.props.canEdit}
              />

              <Toggle
                className="inputFull2"
                name="autoresponder_intervals_enabled"
                label={t("input.label.enableIntervals")}
                errors={formErrors.autoresponder_intervals_enabled}
                onChange={setFormFieldValue}
                checked={formData.autoresponder_intervals_enabled}
                disabled={!formData.autoresponder_enabled || !this.props.canEdit}
              />

              {(formErrors.autoresponder_start_date || formErrors.autoresponder_end_date) && (
                <div className="inputFull2">
                  <WarningBanner
                    msg={formErrors.autoresponder_start_date || formErrors.autoresponder_end_date}
                    color="red"
                  />
                </div>
              )}
              <div
                className={cx("inputFull2", s.wrapDatePicker, {
                  [s.withErrors]: formErrors.autoresponder_start_date || formErrors.autoresponder_start_hour,
                })}
              >
                <label className={s.labelDatePikcer}>{t("input.label.date.start")}</label>
                <div className={s.datePicker}>
                  <DayPicker
                    name="autoresponder_start_date"
                    value={formData.autoresponder_start_date}
                    onChange={setFormFieldValue}
                    errors={formErrors.autoresponder_start_date}
                    required={formData.enabled_during_interval}
                    disabled={
                      !formData.autoresponder_enabled ||
                      !formData.autoresponder_intervals_enabled ||
                      !this.props.canEdit
                    }
                  />
                  <HourPicker
                    name="autoresponder_start_hour"
                    value={formData.autoresponder_start_hour}
                    noLabel
                    errors={formErrors.autoresponder_start_hour}
                    onChange={setFormFieldValue}
                    disabled={
                      !formData.autoresponder_enabled ||
                      !formData.autoresponder_intervals_enabled ||
                      !this.props.canEdit
                    }
                  />
                </div>
              </div>

              <div
                className={cx("inputFull2", s.wrapDatePicker, {
                  [s.withErrors]: formErrors.autoresponder_start_date || formErrors.autoresponder_end_hour,
                })}
              >
                <label className={s.labelDatePikcer}>{t("input.label.date.end")}</label>
                <div className={s.datePicker}>
                  <DayPicker
                    name="autoresponder_end_date"
                    value={formData.autoresponder_end_date}
                    onChange={setFormFieldValue}
                    minDate={formData.autoresponder_start_date}
                    errors={formErrors.autoresponder_start_date}
                    required={formData.autoresponder_intervals_enabled}
                    disabled={
                      !formData.autoresponder_enabled ||
                      !formData.autoresponder_intervals_enabled ||
                      !this.props.canEdit
                    }
                  />

                  <HourPicker
                    name="autoresponder_end_hour"
                    value={formData.autoresponder_end_hour}
                    errors={formErrors.autoresponder_end_hour}
                    noLabel
                    onChange={setFormFieldValue}
                    disabled={
                      !formData.autoresponder_enabled ||
                      !formData.autoresponder_intervals_enabled ||
                      !this.props.canEdit
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
